import { Link, NavLink } from "react-router-dom";
import { Sparkles, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/#nasil", label: "Nasıl Çalışır?" },
  { to: "/#dersler", label: "Dersler" },
  { to: "/#planlar", label: "Planlar" },
  { to: "/#sss", label: "SSS" },
];

export function PublicHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="public-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-zinc-200"
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
          <div className="w-9 h-9 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-xl text-zinc-900 tracking-tight">
            SuperZeka
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              className="text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
              data-testid={`nav-${l.label}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <Link to="/giris" data-testid="header-login-link">
            <Button variant="ghost" className="rounded-full text-zinc-700 hover:bg-zinc-100">
              Giriş Yap
            </Button>
          </Link>
          <Link to="/kayit" data-testid="header-signup-link">
            <Button className="rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white">
              Ücretsiz Başla
            </Button>
          </Link>
        </div>

        <button
          className="md:hidden p-2 -mr-2 text-zinc-700"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              className="text-sm text-zinc-700 py-2"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <div className="flex gap-2 pt-2">
            <Link to="/giris" className="flex-1" onClick={() => setOpen(false)}>
              <Button variant="outline" className="w-full rounded-full">Giriş</Button>
            </Link>
            <Link to="/kayit" className="flex-1" onClick={() => setOpen(false)}>
              <Button className="w-full rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF]">Kayıt</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
